import { Call } from 'starknet';
import { getConfigManager } from '../../config/getConfigManager';
import { MultiCallContract } from '../../services';
import { MULTICALL_CONTRACT_ADDRESS } from '../../constants';
import { PoolPair } from '../../interfaces';
import { createAsyncAtom } from '../../lib/state';
import rpcProviderAtom from '../rpcProviderAtom';

const RESPONSE_CHUNK_SIZE = 5;

const poolAmplificationCoefficientAtom = createAsyncAtom<{
  [key: string]: number;
}>(async get => {
  const provider = await get(rpcProviderAtom);

  const pools = getConfigManager().getConfig().pools;

  const poolsAmplificationCoefficientMap: { [key: string]: number } = {};

  const calldata: (Call & { metadata: { poolPair: PoolPair } })[] = Object.entries(pools)
    // We want to fetch and display in UI only stable pools
    .filter(([, poolConfig]) => poolConfig.pair.stable)
    .map(([, poolConfig]) => ({
      contractAddress: poolConfig.pair.address,
      entrypoint: 'amp_data',
      calldata: [],
      metadata: {
        poolPair: poolConfig.pair,
      },
    }));

  const multiCallContract = new MultiCallContract(MULTICALL_CONTRACT_ADDRESS, provider);

  const result = await multiCallContract.aggregate(calldata);
  if (!result) {
    return {};
  }

  for (let i = 0; i < result.length; i += RESPONSE_CHUNK_SIZE) {
    const poolPair = calldata[i / RESPONSE_CHUNK_SIZE].metadata.poolPair;

    // Index 1 is amp_start reserves
    const ampStart = Number(result[i + 1]);
    // Index 2 is amp_end reserves
    const ampEnd = Number(result[i + 2]);
    // Index 3 is start_time reserves
    const startTime = Number(result[i + 3]);
    // Index 4 is end_time reserves
    const endTime = Number(result[i + 4]);

    if (Date.now() / 1000 > endTime) {
      poolsAmplificationCoefficientMap[poolPair.id] = ampEnd;
    } else if (Date.now() / 1000 < endTime) {
      const offset = (endTime - startTime) / (Date.now() / 1000 - startTime);
      poolsAmplificationCoefficientMap[poolPair.id] = ampStart + (ampEnd - ampStart) / offset;
    } else {
      poolsAmplificationCoefficientMap[poolPair.id] = 0;
    }
  }

  return poolsAmplificationCoefficientMap;
}, 300000);

export default poolAmplificationCoefficientAtom;
